
<div class=" sidenavdata ">
    <img class="raftarlogo ps-4" src="assets/images/top_logo.png" alt="">
    <div class="mt-4 ps-4 logocap d-flex">
        <img class="logocapimage mt-1 " src="assets/images/Vector@1x.png" alt="">
        <div class="logocapdata ms-2">
            <h5>Sequa Capital</h5>
            <p class="text-truncate logocapsubdata">6391 Elgin St. Celing  data is</p>
        </div>
    </div>
    <span class="menudata ps-4 ">MENU</span>
    <!-- <app-mob-header></app-mob-header>
     <app-mob-sidenav></app-mob-sidenav> -->
    <nav class="navbar navbar-expand-lg ">
        <div class="container-fluid">
          <div class="d-flex justify-content-between align-items-center mob-view">
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
            <img class="user" src="assets/images/top_logo.png" alt="">
            <div class="dropdown user ms-5">
              <div class="d-flex align-items-center">
                <img class="rounded-circle dropdown-toggle" type="button" data- bs-toggle="dropdown" aria-expanded="false"
                  width="35px" height="35px" src="assets/images/user-solid.svg">
                <img class="cursor-pointer" src="assets/images/drop.png" (click)="showdropdown()">
              </div>
              <ul class="dropdown-menu border-0 p-3" [ngClass]="isShow ? 'show':'hide'">
                <li>
                  <a class="dropdown-item d-flex align-items-start" *ngFor="let user of users" >
                    <img [src]="user.img">
                    <div class="ms-3">
                      <h4>{{user.heading}}</h4>
                      <p>{{user.para}}</p>
                    </div>
                  </a>
                  </li>
                  <li>
                    <a class="dropdown-item d-flex align-items-start  cursor-pointer" (click)="logout()" >
                      <img src="assets/images/logout.svg">
                      <div class="ms-3">
                        <h4>Logout</h4>
                        <p>Pellentesque vivamus nulla est</p>
                      </div>
                    </a>
                    </li>
              </ul>
            </div>
          </div>
         
          
          <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
            <ul class="navbar-nav  flex-column w-100">
              <li class="nav-item d-flex flex-row align-items-center justify-content-between cursor-pointer"  [routerLink]="['../layout/home']">
                <a class="nav-link active" aria-current="page"  >
                <img class="listimg me-3"width="26px" height="26px" src="assets/images/home-trend-up.svg">Home</a>
                <img class="pe-4" src="assets/images/arrow-right.png">
                
              </li>
              <li class="nav-item d-flex flex-row align-items-center justify-content-between cursor-pointer"  [routerLink]="['../layout/marketplace']">
                <a class="nav-link active" aria-current="page">
                <img class="listimg me-3" width="26px" height="26px" src="assets/images/bag-tick-2.png">MarcketPlace</a>
                <img class="pe-4" src="assets/images/arrow-right.png">
              </li>
              <li class="nav-item d-flex flex-row align-items-center justify-content-between cursor-pointer"  [routerLink]="['../layout/business']">
                <a class="nav-link active" aria-current="page" >
                <img class="listimg me-3" width="26px" height="26px"  src="assets/images/trend-up.png">Business</a>
                <img class="pe-4" src="assets/images/arrow-right.png">
              </li>
              <li class="nav-item d-flex flex-row align-items-center justify-content-between cursor-pointer"  [routerLink]="['../layout/profile']">
                <a class="nav-link active" aria-current="page" >
                <img class="listimg me-3" width="26px" height="26px" src="assets/images/profile-circle.png">Profile</a>
                <img class="pe-4" src="assets/images/arrow-right.png">
              </li>
              <li class="nav-item d-flex flex-row align-items-center justify-content-between cursor-pointer"  [routerLink]="[moreProfile]">
                <a class="nav-link active" aria-current="page" >
                <img class="listimg me-3" width="26px" height="26px" src="assets/images/category-2.png" >More</a>
                <img class="pe-4" src="assets/images/arrow-right.png">
              </li>
            </ul>
          </div>
          
        </div>
        
      </nav>
      <div class="text-center mt-4 ">
        <button class="px-5 py-2 border-0 helpuser"> Help</button>
    </div>
</div>




